module.exports = __webpack_public_path__ + "static/Exo_Diagram_Part01_sprite-90-7b46bb45cbc0497c2d43082041711fa2.png";